import { render, staticRenderFns } from "./ShareInstanceModal.vue?vue&type=template&id=0a8a240e&scoped=true"
import script from "./ShareInstanceModal.vue?vue&type=script&lang=js"
export * from "./ShareInstanceModal.vue?vue&type=script&lang=js"
import style0 from "./ShareInstanceModal.vue?vue&type=style&index=0&id=0a8a240e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a240e",
  null
  
)

export default component.exports